import React from 'react';
import type {TdProps} from '@components/Table/core/Td';
import Td from '@components/Table/core/Td';
import type {ArtistClaim} from '@deezer/next/services/api/Starmania/requests/claim/types';
import ArtistClaimDetails from './ArtistClaimDetails';

type ArtistClaimCellProps = {
	claim: ArtistClaim;
} & TdProps;

const ArtistClaimCell = ({claim, ...rest}: ArtistClaimCellProps) => {
	return (
		<Td whiteSpace="pre-wrap" {...rest}>
			<ArtistClaimDetails artist={claim} />
		</Td>
	);
};

export default ArtistClaimCell;
